export function generateCommonHeadingLargeTitle(area, eventTypeText) {
  const label = eventTypeText.replace('・お見合いパーティー', '')
  return `${area}の${label}人気イベントランキング`
}
